export let props = ['time']
export let model = {
    year:new Date().format('yyyy'),
    showSeason:false
}
export let computed = {
    currenttime: {
        get () {
            return this.time
        },
        set (val) {
            this.$emit('update:time', val)
        }
    },
}
